// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qualification_module-component .title {\n  text-transform: uppercase;\n  font-family: Catamaran;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 30px;\n  /* identical to box height */\n  text-align: center;\n  color: var(--primary); }\n\n.qualification_module-component .container-table-qualifications {\n  max-height: 600px;\n  overflow-y: auto; }\n\n.qualification_module-component hr {\n  border: 1px solid var(--secondary); }\n", ""]);
// Exports
module.exports = exports;
